import { Button, Flex, H2, Icon } from "orcs-design-system";
import PropTypes from "prop-types";
import React from "react";

import * as placeholder from "src/components/Placeholder/PlaceholderStyles";
import icon from "src/config/icons";

const Header = ({
  isDisplayNavigateUp,
  loading,
  onNavigateUp,
  heading,
  navigateUpLabel,
}) => {
  return loading ? (
    <placeholder.Line
      data-testid="cp-explore-placeholder-heading"
      width={160}
      height={32}
    />
  ) : (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      flexWrap="wrap"
      mb="r"
    >
      <H2 weight="light">{heading}</H2>
      {isDisplayNavigateUp && (
        <Button
          data-testid="cp-explore-navigate-up-btn"
          onClick={onNavigateUp}
          small
          iconLeft
        >
          <Icon icon={icon.arrowUp} />
          {navigateUpLabel}
        </Button>
      )}
    </Flex>
  );
};

Header.propTypes = {
  isDisplayNavigateUp: PropTypes.bool,
  onNavigateUp: PropTypes.func,
  loading: PropTypes.bool,
  heading: PropTypes.string,
  navigateUpLabel: PropTypes.string,
};

export default Header;
